<template>
    <div class="loading-container" v-show="visible">
        <div class="loading-inner">
            <img class="loading-img" src="../../assets/ebbly_loading.gif" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            isFullScreen: true //是否全屏
        };
    }
};
</script>

<style lang="scss" scoped>
.loading-container {
    position: fixed;
    z-index: 2014;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba($color: #000000, $alpha: 0.5);

    .loading-inner {
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 300px;
        height: 210px;
        margin: 0 auto;
        border-radius: 20px;

        .loading-img {
            width: 200px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/loading/Index.vue